const topics = [
  { label: '热血战斗', count: '2,380部', hot: true },
  { label: '恋爱校园', count: '1,950部', hot: true },
  { label: '奇幻冒险', count: '1,720部', hot: false },
  { label: '悬疑推理', count: '980部', hot: true },
  { label: '搞笑日常', count: '1,560部', hot: false },
  { label: '都市职场', count: '830部', hot: false },
  { label: '科幻未来', count: '650部', hot: false },
  { label: '治愈温情', count: '1,120部', hot: true },
  { label: '恐怖灵异', count: '540部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          按题材快速发现喜欢的完结漫画全集，总有你爱看的类型
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-2 px-5 py-3 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-fire-fill text-xs"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}